// Static content: services and suburbs (used across the marketing site)

export const PHONE = "1800 836 390";
export const PHONE_TEL = "tel:1800836390";
export const BRAND = "Tech Emergency";
export const HOURS = "Mon – Sat · 9:00 AM – 7:00 PM";

// Google review deep-link — opens the "Write a review" pop-up directly.
// Service-Area-Business short link from Google Business Profile.
export const GOOGLE_REVIEW_URL = "https://g.page/r/CS0k2UO2wit0EBM/review";
// Direct deep-link to the "Reviews" tab of your Google Business Profile (Service Area Business).
// Uses your Place ID — opens straight into the list of all reviews, no search-results detour.
export const GOOGLE_LISTING_URL = "https://search.google.com/local/reviews?placeid=ChIJ7-1wJR_HHWERLSTZQ7bCK3Q";

export const services = [
  {
    slug: "computer-repairs",
    audience: "home",
    title: "Mobile Computer Repairs",
    seoTitle: "Mobile Computer Repairs Adelaide | Tech Emergency",
    seoDescription:
      "Mobile computer repairs across Adelaide — we come to your home. Slow computers, laptop repairs, Windows & Mac, virus removal, upgrades. From $139 first hour. Call 1800 836 390.",
    icon: "Monitor",
    short:
      "Mobile computer repairs Adelaide — fast diagnosis & on-site repair for hardware failures, slow performance, and software issues. Windows and Apple Mac. We come to your home or business across metro Adelaide.",
    long:
      "Tech Emergency offers genuine mobile computer repairs across Adelaide. Instead of unplugging your PC and dragging it to a shop, we drive to your home or office — Glenelg, Norwood, Mawson Lakes, Tea Tree Gully, Adelaide CBD and suburbs across our service area — and fix it where you are. Slow laptops, dead PCs, blue screens, failed hard drives, ransomware infections, Windows or macOS reinstalls, SSD upgrades, lost-password lockouts — all handled on-site by your police-checked, Adelaide-based technician. Zero callout fee, fixed quotes, no fix · no fee.",
    bullets: [
      "Mobile on-site computer repairs — we come to you across our Adelaide service area",
      "Windows PC repairs — slow PCs, dead laptops, virus removal, OS reinstalls",
      "Apple Mac repairs — MacBook, iMac, Mac mini, macOS reinstalls",
      "SSD upgrades & data clone (typically 60–90 minutes on-site)",
      "Failed drive recovery & accidentally deleted file rescue",
      "Police-checked technician · Zero callout fee · No fix no fee",
    ],
    cover:
      "https://images.unsplash.com/photo-1597852074816-d933c7d2b988?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "tech-support",
    audience: "home",
    title: "Tech Support",
    seoTitle: "Home IT Support Adelaide | Tech Emergency",
    seoDescription:
      "Home IT support across Adelaide — printers, new device setup, patient computer help for seniors, phones and tablets. Friendly on-site visits from $139. Call 1800 836 390.",
    icon: "LifeBuoy",
    short: "Same-day on-site or remote help for PCs, Macs, iPhones, iPads, Android phones, tablets, printers and Apple Watches.",
    long: "A real human who answers the phone, comes to your door, and explains what's actually going on. We support the whole stack: Windows PCs, Macs, iPhones, iPads, Android phones (Samsung Galaxy, Google Pixel, Motorola, OPPO), Android tablets, Apple Watches, smartwatches and connected devices. No call centres, no scripts, no overseas remote takeovers.",
    bullets: [
      "On-site visits across the Adelaide metro",
      "iPhone & iPad setup, configuration and hands-on help",
      "Android phone & tablet setup, configuration & optimisation",
      "Apple Watch & smartwatch pairing, syncing, and setup",
      "Data transfers — iPhone-to-iPhone, iPhone-to-Android, Android-to-Android",
      "Google Drive / Google Photos / iCloud backup configuration",
      "Printer setup & troubleshooting — wireless, USB and network printers",
      "Remote support for quick fixes — no visit needed",
      "New computer setup & data transfer from your old machine",
      "Senior-friendly, jargon-free explanations",
      "Police-checked, family-safe technician",
    ],
    cover: "https://images.unsplash.com/photo-1620368523635-df9d83338fc1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "email-solutions",
    audience: "home",
    title: "Email Solutions",
    icon: "Mail",
    short: "Locked out, hacked, missing emails, or migrating providers — we fix and configure Outlook, Apple Mail, Gmail and more.",
    long: "Outlook, Apple Mail (on iPhone, iPad and Mac), Gmail, Microsoft 365, Google Workspace, custom domains. We get your email working and keep it secure with MFA — across every device you own.",
    bullets: [
      "Account recovery & MFA setup",
      "Apple Mail / iPhone Mail configuration",
      "Microsoft 365 setup for home users — Word, Excel, OneDrive, Family plans",
      "Custom domain (you@yourbusiness.com.au) setup",
      "Migration between providers without data loss",
      "Spam, deliverability and DNS (SPF/DKIM/DMARC) fixes",
    ],
    cover: "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "wifi-troubleshooting",
    audience: "home",
    title: "Home Wi-Fi, Modem & NBN Troubleshooting",
    icon: "Wifi",
    short: "Red flashing NBN box, WiFi dead zones, that one room where Netflix always buffers — solved on-site.",
    long: "We diagnose the real cause of slow or dropped internet — whether it's an ageing NBN modem, a poorly placed router, channel congestion, or just an ISP issue worth escalating. Telstra, Optus, Belong, Aussie Broadband, TPG — we've worked with the lot.",
    bullets: [
      "NBN modem & router setup and reconfiguration — your ISP-supplied equipment",
      "NBN connection drops & red-light diagnosis",
      "Wi-Fi coverage diagnosis — find the dead zones and fix them",
      "Router & mesh optimisation — getting the most from the equipment you already own",
      "Channel & band optimisation",
      "ISP coordination — we talk to Telstra/Optus/iiNet so you don't have to",
      "Starlink router configuration & mesh integration (see our dedicated Starlink service)",
      "Ubiquiti UniFi home networks — see our dedicated Home UniFi service",
    ],
    cover: "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "unifi-home-networking-adelaide",
    audience: "home",
    title: "Home UniFi Networking (Ubiquiti)",
    icon: "Network",
    short:
      "Residential Ubiquiti UniFi specialists in Adelaide — new home UniFi installations, Wi-Fi access points, gateways, switches, troubleshooting, upgrades and optimisation. Yes, we do UniFi for homes.",
    long:
      "Yes — we absolutely provide residential Ubiquiti UniFi services. UniFi is the gold standard for serious home networks: whole-home Wi-Fi that actually reaches the back rooms, proper gateways, PoE switches and central management without ongoing licensing fees. We design and install new residential UniFi networks, troubleshoot existing setups, and upgrade or optimise the gear you already own — from a single access point to a full home network with hard-wired backhaul.",
    bullets: [
      "UniFi Wi-Fi & access points — placement, installation and tuning for full home coverage",
      "UniFi gateways — Cloud Gateway & Dream Machine setup and configuration",
      "UniFi switches & networking — PoE switches, VLANs and hard-wired backhaul",
      "New residential UniFi installations — designed around your home's layout",
      "Existing UniFi troubleshooting — dropouts, slow roaming, adoption issues",
      "UniFi upgrades & optimisation — firmware, channel planning, performance tuning",
      "General residential UniFi network assistance — advice, expansion and ongoing support",
    ],
    cover: "https://images.unsplash.com/photo-1551033406-611cf9a28f67?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "starlink-setup-troubleshooting-adelaide",
    audience: "home",
    title: "Starlink Setup & Troubleshooting",
    icon: "Satellite",
    short:
      "Starlink running slow, dropping out, or won't connect? On-site Starlink network setup, router configuration, mesh integration and troubleshooting across Adelaide and the Hills. (Network side only — we don't do roof dish mounting.)",
    long:
      "Starlink is a brilliant NBN alternative for the Adelaide Hills, outer suburbs and anywhere fixed-line internet underperforms — but the kit only works as well as the network behind it. We handle everything on the network side: initial setup and activation through the Starlink app, bypass mode into your own router or mesh system (Deco, Eero, Orbi and similar), Ethernet adapter configuration, Wi-Fi coverage tuning, and diagnosing the classic Starlink complaints — random dropouts, obstruction alerts, slow speeds at peak times, and devices that won't stay connected. We'll also give you an honest assessment of whether Starlink or NBN is the better fit for your address. Note: we handle the network and configuration side only — we don't do physical dish mounting on roofs (a licensed antenna installer or handyman covers that; we're happy to work alongside them).",
    bullets: [
      "Starlink kit setup & activation — app, account, dish placement advice",
      "Bypass mode into your own router or mesh system (Deco / Eero / Orbi)",
      "Starlink Ethernet adapter setup for hard-wired PCs and devices",
      "Dropout, obstruction-alert and slow-speed diagnosis",
      "Honest Starlink vs NBN advice for your specific address",
      "Network side only — no roof dish mounting (we work alongside your installer)",
    ],
    cover: "/images/services/starlink-adelaide.jpg",
  },
  {
    slug: "anti-scamming-cyber-awareness",
    audience: "home",
    title: "Anti-Scamming & Cyber Awareness",
    icon: "ShieldAlert",
    short: "If you've been scammed — or want to make sure you never are — we help.",
    long: "Education first, then practical lockdown. We work with families and seniors to recognise scams, lock down devices, and recover safely if something has already happened.",
    bullets: [
      "Post-scam device clean & recovery",
      "1-on-1 awareness sessions for families & seniors",
      "Browser, email, and bank account hardening",
      "Free over-the-phone triage if you've just been scammed",
    ],
    cover: "https://images.unsplash.com/photo-1562813733-b31f71025d54?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "business-cyber-security",
    audience: "business",
    title: "Business Cyber Security",
    icon: "ShieldCheck",
    short: "Enterprise-grade defence — Huntress Managed EDR, hardening and 24/7 monitoring, sized and priced for Adelaide small businesses.",
    long: "We bridge the gap between 'the guy who fixes computers' and 'the expensive city-firm consultants'. Prevention, detection, and recovery — all managed locally. We deploy Huntress Managed EDR for around-the-clock threat detection backed by a human SOC, roll out MFA across your business, harden every endpoint, and keep immutable off-site backups so ransomware can never hold you hostage.",
    bullets: [
      "Huntress Managed EDR — 24/7 endpoint detection & response with human threat hunters",
      "Multi-Factor Authentication rollout across staff and systems",
      "Cybersecurity hardening — endpoints, servers and cloud accounts",
      "Application control & continuous patching",
      "Off-site immutable backups",
      "Ongoing monitoring & support — we watch it so you don't have to",
      "Incident response & ransomware recovery",
    ],
    cover: "https://images.unsplash.com/photo-1562813733-b31f71025d54?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "pos-network-software-support",
    audience: "business",
    title: "Business POS Systems",
    icon: "CreditCard",
    short: "Complete POS system installation, deployment and support for Adelaide retail & hospitality — delivered in collaboration with Ninja IT.",
    long: "A frozen terminal or dropped connection at checkout means lost revenue. In collaboration with Ninja IT, we deliver comprehensive Point of Sale solutions for Adelaide businesses — from full POS system installation and deployment for new venues, through to rapid on-site rescue when the checkout goes down mid-service. POS hardware setup and configuration, terminal replacements and upgrades, receipt printers, barcode scanners, EFTPOS connectivity, network reliability and ongoing software support — one local team accountable for the whole point-of-sale stack.",
    bullets: [
      "POS system installation & deployment — new venues and upgrades (with Ninja IT)",
      "POS hardware setup & configuration — terminals, receipt printers, barcode scanners",
      "POS terminal replacement & upgrades",
      "POS network connectivity — reliable checkout-lane Wi-Fi and cabling with VLAN segmentation",
      "EFTPOS connectivity assistance — Tyro, Smartpay, Westpac, CBA and more",
      "POS troubleshooting — frozen terminals, dropped gateways, printer disconnects",
      "POS software support — updates, configuration and local server sync issues",
      "Ongoing POS technical support for businesses",
    ],
    cover: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "data-recovery",
    audience: "home",
    title: "Data Recovery",
    icon: "HardDrive",
    short: "Recover photos, documents and business files from failed laptops, external hard drives and SSDs across Adelaide.",
    long: "Dropped the laptop? External drive making clicking noises? Photos gone after a Windows update? We handle logical data recovery from failed laptop HDDs and SSDs, external USB drives and SD cards on-site across Adelaide. We do not run a clean-room (so we don't open physically destroyed platter drives) — but the vast majority of 'dead drive' jobs are logical, file-system or controller failures we can recover from, often the same day. Quoted upfront. No fix · no fee.",
    bullets: [
      "Laptop HDD & SSD logical recovery (Windows, Mac)",
      "External USB drive and portable SSD recovery",
      "Photo, document and email file recovery",
      "Accidentally deleted file & emptied-recycle-bin recovery",
      "Corrupt partition / unreadable drive rescue",
      "Backup setup so it never happens again — cloud and local",
      "Honest assessment — we'll tell you immediately if a clean-room specialist is needed",
    ],
    cover: "https://images.unsplash.com/photo-1597852074816-d933c7d2b988?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "business-voip-phone-systems-adelaide",
    audience: "business",
    title: "Business VoIP, Hosted PBX & Corporate Voice",
    icon: "PhoneCall",
    short: "Business VoIP phone systems in collaboration with TEL5 — hosted VoIP, cloud PBX, call routing, number porting and ongoing support for Adelaide SMBs.",
    long: "In collaboration with TEL5, we deliver complete business phone systems for Adelaide SMBs — hosted VoIP and cloud PBX with call routing, auto attendants, hunt groups, voicemail-to-email and multi-site support, backed by our local on-site engineering. From replacing ageing copper PSTN/ISDN lines with SIP trunks, to deploying the platform across staff laptops and mobiles, to configuring QoS on your firewall so calls never drop mid-sentence — one local team handles the provider, the network and the hardware. We also work with 3CX, RingCentral and Microsoft Teams Calling where they're the better fit.",
    bullets: [
      "Hosted VoIP & Cloud PBX — in collaboration with TEL5, fully provisioned and maintained",
      "Business phone systems — deskphones, softphones and mobile apps rolled out to staff",
      "Call routing, auto attendants & hunt groups — callers always reach the right person",
      "Voicemail & voicemail-to-email setup",
      "Number porting — keep your existing numbers through the switch",
      "Multi-site phone systems — one platform across every location",
      "SIP Trunking & legacy upgrades — transition PSTN/ISDN copper to cloud voice",
      "QoS configuration on routers and firewalls — eliminate choppy audio and dropouts",
      "Ongoing VoIP support — changes, additions and troubleshooting handled locally",
    ],
    cover: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "data-cabling",
    audience: "business",
    title: "Data Cabling & Structured Wiring",
    icon: "Network",
    short: "Cat6 and Cat6A structured data cabling for Adelaide businesses and commercial premises — done neatly, terminated properly, tested.",
    long: "Wi-Fi is great until your business needs real, lag-free, gigabit speed — for workstations, servers, access points and PoE devices. We run new Cat6 and Cat6A structured cabling for Adelaide businesses: multi-drop patch panels, wall plates, comms cupboards and full commercial fit-outs. Every termination is certified-tested before we leave.",
    bullets: [
      "Cat6 / Cat6A structured cabling for offices, retail and commercial fit-outs",
      "Patch panels, wall plates and structured cabling for SMB offices",
      "Hard-wired backhaul for Ubiquiti UniFi access points",
      "Ethernet runs to workstations, servers, printers and PoE devices",
      "Neat, in-wall or ceiling-routed cable paths — not dangling extension leads",
      "Tester-certified terminations on every drop",
    ],
    cover: "https://images.unsplash.com/photo-1551033406-611cf9a28f67?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "hardware-firewalls",
    audience: "business",
    title: "Check Point Firewalls — Deployment & Management",
    icon: "Shield",
    short: "Check Point next-generation firewall deployment and ongoing management for Adelaide businesses — enterprise-grade protection, locally supported.",
    long: "A consumer modem-router is not a firewall. For any Adelaide business handling customer data, payments, or remote workers, a properly managed next-generation firewall is the single biggest security uplift you can make. We deploy and manage Check Point firewalls — including the Check Point Quantum family — with threat prevention, intrusion prevention (IPS), content filtering, application control, and secure VPN for remote staff, sized and priced for small and medium businesses. Our managed firewall service covers deployment, configuration, ongoing monitoring, rule management and firmware patching — all handled locally.",
    bullets: [
      "Check Point next-generation firewall supply, deployment and configuration",
      "Check Point Quantum — enterprise-grade protection sized for SMBs",
      "Threat prevention — IPS, anti-bot, anti-virus and zero-day protection",
      "Secure Remote Access VPN for staff working from home or on the road",
      "Site-to-Site VPN linking multiple business locations securely",
      "Content filtering and application control policies",
      "Managed firewall service — ongoing monitoring, rule updates and firmware patching",
      "Business firewall health checks — monthly reviews of rules, logs and threats",
    ],
    cover: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "managed-it-services-adelaide",
    audience: "business",
    title: "Managed IT Services",
    icon: "Server",
    short: "Ongoing managed IT for Adelaide small and medium businesses — endpoint management, monitoring, patching and a local team that answers the phone.",
    long: "Stop paying for IT only after something breaks. Our managed IT service keeps your Adelaide business running: proactive endpoint management across every laptop and desktop (Microsoft Intune where applicable), continuous patching, 24/7 monitoring with Huntress-backed security, asset management, and unlimited phone triage with a real local technician. Pricing is discussed and negotiated as part of your agreement — no offshore call centres.",
    bullets: [
      "Endpoint management — every staff laptop and desktop patched, secured, documented",
      "Ongoing monitoring & support — issues caught before they become outages",
      "Microsoft 365 administration and user on/off-boarding",
      "Backup management with regular restore testing",
      "Vendor management — we deal with your ISP, software and hardware suppliers",
      "Pricing discussed and negotiated to fit your business — no surprises",
    ],
    cover: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "microsoft-365-business-adelaide",
    audience: "business",
    title: "Microsoft 365 for Business",
    icon: "Cloud",
    short: "Microsoft 365 deployment, security and management for Adelaide businesses — Entra ID, email security, spam protection and MFA done properly.",
    long: "Microsoft 365 is the backbone of most Adelaide businesses — and most deployments we audit are dangerously misconfigured. We deploy and manage the full stack: tenant setup and migrations, Microsoft Entra ID (identity and conditional access), M365 security baselines, email security with anti-phishing and spam protection (SPF/DKIM/DMARC), SharePoint/OneDrive structure, and MFA enforced across every account. Managed locally, explained in plain English.",
    bullets: [
      "Microsoft 365 deployment & migration — from Gmail, IMAP or an older tenant",
      "Microsoft Entra ID — identity, single sign-on and conditional access policies",
      "Microsoft 365 security baseline — hardened against account takeover",
      "Email security & spam protection — anti-phishing, SPF/DKIM/DMARC",
      "MFA rollout across every staff account",
      "Microsoft Intune — endpoint and mobile device management, where applicable",
      "SharePoint & OneDrive setup with sensible permissions",
      "Ongoing administration — licensing, on/off-boarding, support",
    ],
    cover: "https://images.unsplash.com/photo-1633419461186-7d40a38105ec?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    slug: "unifi-business-networking-adelaide",
    audience: "business",
    title: "UniFi Business Networking & Wi-Fi",
    icon: "Network",
    short: "Ubiquiti UniFi business networks — gateways, switches, enterprise Wi-Fi, VLANs and VPN — designed, installed and managed for Adelaide businesses.",
    long: "We design, install and manage Ubiquiti UniFi networks for Adelaide businesses — the platform that gives you enterprise-grade networking without enterprise licensing costs. UniFi gateways, PoE switches and access points tuned to your floor plan, VLAN segmentation separating POS, staff, and guest traffic, business-grade Wi-Fi that stays fast under load, and secure VPN access for remote and multi-site teams.",
    bullets: [
      "Ubiquiti UniFi network design — gateways, switches, access points",
      "Business Wi-Fi solutions — coverage tuned to your floor plan, fast under load",
      "VLAN segmentation — POS, staff, guest and IoT traffic properly separated",
      "Secure Remote Access VPN for staff working anywhere",
      "Site-to-Site VPN for multi-location businesses",
      "Ongoing management — firmware, monitoring and support handled locally",
    ],
    cover: "https://images.unsplash.com/photo-1551033406-611cf9a28f67?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const regions = [
  { name: "North", suburbs: ["Mawson Lakes", "Golden Grove", "Greenwith", "Salisbury", "Elizabeth", "Gawler", "Parafield Gardens", "Modbury", "Tea Tree Gully", "Burton", "Craigmore", "Munno Para", "Ingle Farm", "Pooraka", "Enfield"] },
  { name: "East & Hills", suburbs: ["Norwood", "Burnside", "Magill", "Campbelltown", "Stirling", "Mount Barker", "Kensington", "Unley", "Malvern", "Marden", "Rostrevor", "Athelstone", "Payneham", "St Peters", "Aldgate"] },
  { name: "South", note: "Not sure if we service your area? Contact us to discuss your location and what you need help with — we'll let you know if we can assist.", suburbs: ["Marion", "Morphett Vale", "Noarlunga Centre", "Hallett Cove", "Aberfoyle Park", "Brighton", "Edwardstown", "Blackwood", "Sturt", "Plympton", "Mitcham", "Reynella", "Flagstaff Hill"] },
  { name: "West & CBD", suburbs: ["Adelaide CBD", "Port Adelaide", "Glenelg", "Henley Beach", "West Lakes", "Prospect", "Hindmarsh", "Mile End", "Croydon", "Findon", "Grange", "Fulham", "Beverley", "Torrensville", "Woodville", "Fitzroy", "Wingfield", "Regency Park", "Semaphore"] },
];

export const allSuburbs = regions.flatMap((r) =>
  r.suburbs.map((s) => ({ name: s, region: r.name, slug: s.toLowerCase().replace(/\s+/g, "-") }))
);

export const trustSignals = [
  "Zero callout fee · Adelaide's electric IT fleet",
  "Adelaide based — owner-operated, no big national corporates",
  "No fix · No fee guarantee",
  "Easy Payment Onsite — EFTPOS or cash payment upon job completion",
  "7-day warranty on all our labour",
  "Family & senior safe",
  "Police-checked technician",
  "Transparent, fair pricing",
  "Mon–Sat, 9am–7pm response",
  "Google 5.0★ rated",
];

export const stats = [
  { value: "5.0★", label: "Google rating", href: GOOGLE_LISTING_URL },
  { value: "On-site", label: "Owner-operated" },
  { value: "100%", label: "Adelaide based" },
  { value: "6 days", label: "Open Mon–Sat" },
];
